import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';
import b2b from '../assets/images/b2b-white-label-head.jpg';

const step = [
	'No minimum wallet',
	'Same day delivery',
	'Pre Integrated GDS & APIs.',
	'Multiple Supplier Inventory',
	'Offline Flight Inventory Management',
	'Real time booking',
	'Real time cancellation',
	'Real time availability',
	'Live Fare rules',
	'Responsive design',
	'All device support',
	'Custom B2C Home Page',
	'Logo Design',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const B2BWL = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	function progressBarScroll() {
		let winScroll =
				document.body.scrollTop || document.documentElement.scrollTop,
			height =
				document.documentElement.scrollHeight -
				document.documentElement.clientHeight,
			scrolled = (winScroll / height) * 100;
		document.getElementById('progressBar').style.width = scrolled + '%';
	}

	window.onscroll = function () {
		progressBarScroll();
	};
	return (
		<div>
			<Navbar />
			<div className='header' style={{ marginTop: 80 }}>
				<div className='progress-container'>
					<div className='progress-bar' id='progressBar'></div>
				</div>
			</div>
			<div
				style={{
					backgroundImage: `url(${b2b})`,
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					B2B WHITE LABEL
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					B2B WHITE LABEL
				</h6>
			</div>
			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30 }}>
					B2B White Label Travel Website
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/23.png' />
						</Grid>
						<Grid item xs={8}>
							<p>
								B2B White Label system is the best Travel portal for those who
								want to enhance their travel business with a small amount of
								money. Our B2B white label system is user friendly and
								technology enabled.
							</p>
							<br />
							<p>
								Our strong B2B Booking Systems have GDS API Integration or third
								party API integration that facilitates 24/7 travel solutions for
								flight booking, coach booking, hotel booking and car booking.
							</p>
							<br />
							<p>
								B2B Travel Portal Solution connect customers and travel
								agencies. On B2B Travel Portals only registered agents can use
								the services. Our B2B Travel Portal provides complete control of
								creating agents and their logins, top-up and deduction of credit
								limit/balance, activating or deactivating agents, monitoring
								bookings/commissions/sales, modifying mark-ups/discounts. B2B
								Travel Portals has all the travel services like Flight Booking,
								Hotel Booking, Bus Booking and Car Booking.
							</p>
						</Grid>
					</Grid>
				</Container>
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={8}>
							<p>
								As our team have 10+ years great experience in travel technology
								so we develop B2B Travel Portals with all updated features. Arya
								Aviation provides technically strong and reliable B2B Travel
								Portal Solution so you and your sub Agent with can grow your
								business.
							</p>
							<br />
							<p>
								To avoid system or office dependency we develop fully responsive
								and device friendly user interface. Any B2B user can login from
								mobile and make bookings without interruption. Arya Aviation
								provides unlimited bandwidth so n number of user can access
								system and use services quickly. Our user friendly interface and
								easy to use B2B booking system provides seamless booking. So if
								you are having a travel agency and you are working offline or
								using 3rd party links to make bookings you must start your
								Online travel agency.
							</p>
							<br />
							<p>
								In B2B Portal, you can create sub agents for your Agency. Agents
								can login and can use services by using their B2B panel.
							</p>
						</Grid>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/bst-trvl-agency.jpg' />
						</Grid>
					</Grid>
				</Container>
			</div>
			<div style={{ background: '#0a74c0', padding: 13 }}>
				<Container>
					<p style={{ color: 'white', fontSize: 14 }}>
						The fastest way to grow your business with the leader in Travel
						Technology Check out our options and features included.
					</p>
				</Container>
			</div>
			<Container style={{ background: '#eaeaea', marginTop: 20, padding: 20 }}>
				<p style={{ fontSize: 14, fontWeight: 'bold' }}>
					Features of B2C Travel Portal:-
				</p>
			</Container>
			<Container style={{ marginTop: 10 }}>
				<Grid container>
					<Grid item xs={4}>
						{step.map((d) => {
							return <p style={{ marginTop: 5 }}>{d}</p>;
						})}
					</Grid>
					<Grid item xs={4}>
						{step2.map((d) => {
							return <p style={{ marginTop: 5 }}>{d}</p>;
						})}
					</Grid>
					<Grid item xs={4}>
						{step3.map((d) => {
							return <p style={{ marginTop: 5 }}>{d}</p>;
						})}
					</Grid>
				</Grid>
			</Container>
			<Footer />
		</div>
	);
};

export default B2BWL;
